const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

document.addEventListener('alpine:init', () => {
  Alpine.data('formState', () => ({
    isSSO: false,
    isPassword: false,
    isLoading: false,
    email: '',
    password: '',

    isValidPassword() {
      return this.password.length > 5;
    },

    isValidEmail() {
      return emailRegex.test(this.email);
    },

    onPressEnter() {
      if (!this.isValidEmail() || !this.isSSO) {
        return;
      }

      this.$refs.formSSO.submit();
    },

    async checkDomain() {
      if (!this.isValidEmail()) {
        return;
      }

      this.isLoading = true;
      this.isSSO = false;
      this.isPassword = false;

      try {
        const { data } = await axios.post('/sso/check', { email: this.email });

        if (data.type === 'sso') {
          this.isSSO = true;
        } else {
          this.isPassword = true;
        }
      } catch (err) {
        console.error('error checking domain:', err);
        this.isPassword = true;
      }

      this.isLoading = false;
    },
  }));
});
